import InboxManager from '@/components/admin/InboxManager';

const columns = [
    { key: 'name', label: 'Name', primary: true },
    { key: 'email', label: 'Email' },
    { key: 'subject', label: 'Subject', render: (r) => r.subject || '—' },
    {
        key: 'message',
        label: 'Message',
        render: (r) => (
            <span className="text-xs text-muted-foreground line-clamp-1">{r.message}</span>
        ),
    },
    {
        key: 'created_at',
        label: 'Date',
        render: (r) => <span className="text-xs">{r.created_at?.slice(0, 10)}</span>,
    },
];

const renderDetail = (v) => (
    <div className="space-y-3 text-sm">
        <Row label="Name">{v.name}</Row>
        <Row label="Email">
            <a href={`mailto:${v.email}`} className="text-[hsl(var(--primary))] hover:underline">
                {v.email}
            </a>
        </Row>
        <Row label="Phone">{v.phone || '—'}</Row>
        <Row label="Subject">{v.subject || '—'}</Row>
        <Row label="Message">
            <div className="text-foreground/85 whitespace-pre-line">{v.message}</div>
        </Row>
        <Row label="Submitted">
            <span className="text-xs text-muted-foreground">{v.created_at}</span>
        </Row>
    </div>
);
const Row = ({ label, children }) => (
    <div className="grid grid-cols-3 gap-4">
        <div className="text-muted-foreground text-xs uppercase tracking-widest font-medium">
            {label}
        </div>
        <div className="col-span-2">{children}</div>
    </div>
);

export default function AdminContactsPage() {
    return (
        <InboxManager
            kind="contacts"
            title="Contact submissions"
            description="Public contact form messages."
            columns={columns}
            renderDetail={renderDetail}
        />
    );
}
